export default __webpack_public_path__ + "static/media/abcnew.4afade13.png";